/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DiskUtilizationBatchResponse {
    getFixupPrototypeFunction() { return DiskUtilizationBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<DiskUtilizationBatchResponse>): DiskUtilizationBatchResponse {
        let obj = Object.assign(new DiskUtilizationBatchResponse(), model);
        DiskUtilizationBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DiskUtilizationBatchResponse>): DiskUtilizationBatchResponse {
        if (!model) return null;
        return DiskUtilizationBatchResponse.newInstance(<DiskUtilizationBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DiskUtilizationBatchResponse) {
        if (!obj) return;

        models.DiskUtilizationBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DiskUtilizationBatchResponse): boolean {
        Object.setPrototypeOf(obj, DiskUtilizationBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.values) {
            for (let val of this.values) {
                models.DiskUtilizationMetricDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * Path For which metrics are being measured.
     */
    path: string;

    /**
     * Device name For which metrics are being measured.
     */
    device: string;

    /**
     * Type of the disk partition for which metrics are being measured.
     */
    fstype: string;

    /**
     * Data Related to the Disk Utilization Metric.
     */
    values: Array<models.DiskUtilizationMetricDetail>;

}
